export default __webpack_public_path__ + "static/media/image5.bac095ad.jpg";